import TeamTile from './TeamTile'
import { Card } from 'antd'
import React from 'react'

export default function GroupCardV2({ formatPlacement, group, name, placements, setPlacements }) {
  const selectedTeams = placements
    .map(teamValue => group.find(team => String(team.value) === String(teamValue)))
    .filter(Boolean)
  const unselectedTeams = group.filter(team => !placements.some(value => String(value) === String(team.value)))

  const handleSelection = (teamValue) => {
    if (placements.some(value => String(value) === String(teamValue))) {
      setPlacements(placements.filter(value => String(value) !== String(teamValue)))
      return
    }

    if (placements.length >= group.length) {
      return
    }

    setPlacements([...placements, teamValue])
  }

  return (
    <Card
      key={name}
      className="group-card"
      title={<h2 className="wc-font wc-primary">{`Group ${name.toUpperCase()}`}</h2>}
    >
      {selectedTeams.map((team, idx) => (
        <TeamTile
          key={team.value}
          selectionLabel={formatPlacement(idx + 1)}
          selectionPosition={idx + 1}
          team={team}
          onClick={() => handleSelection(team.value)}
        />
      ))}
      {unselectedTeams.map(team => (
        <TeamTile
          key={team.value}
          team={team}
          onClick={() => handleSelection(team.value)}
        />
      ))}
    </Card>
  )
}
